import { HttpBackend } from '@angular/common/http';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';

export function translateLoaderFactory(http: HttpBackend, folders: string[]): MultiTranslateHttpLoader {
  const resources = folders.map(f => ({ prefix: `./assets/i18n/${f}/`, suffix: '.json' }));

  return new MultiTranslateHttpLoader(http, resources);
}
